import { getDefaultStore } from "jotai";
import { accessTokenAtom, userAtom } from "../stores/auth";
import type { User } from "@repo/shared-types";
import { authApi } from "..";

export const clearToken = () => {
  const store = getDefaultStore();
  store.set(accessTokenAtom, null);
};

export const getToken = () => {
  const store = getDefaultStore();
  return store.get(accessTokenAtom);
};

export const setToken = (token: string, loadUserFromApi = true) => {
  const store = getDefaultStore();
  store.set(accessTokenAtom, token);
  if (loadUserFromApi) {
    loadUser();
  }
};

export const setUser = (user: User | null) => {
  const store = getDefaultStore();
  store.set(userAtom, user);
};

const loadUser = () => {
  authApi.getCurrentUser().then(async (response) => {
    if (response.ok) {
      const user = await response.json();
      setUser(user);
    }
  });
};

export const logout = () => {
  clearToken();
  setUser(null);
  window.location.href = "/login";
};
